import { boolean, object, optional } from 'superstruct';
import { makeRecord } from '@arc/shared/util-js';
import { permissionSystem } from '@arc/shared/util-permissions';
const PermissionValuesDto = object(makeRecord(permissionSystem.actionTypes, () => optional(boolean())));
export const EditPermissionsDto = object(makeRecord(permissionSystem.permissionTypes, () => optional(PermissionValuesDto)));